export const PRODUCTS_PER_PAGE = 60;

export const TOTAL_PRODUCTS_WITH_EAGER_LOADING = 8;
